// extracted by extract-css-chunks-webpack-plugin
module.exports = {"links":"app-components-header-navlinks--links"};